/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const awsCredentialsSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-common-auth:AwsCredentials',
    type: 'object',
    properties: {
        identityID: { type: 'string', pattern: '[\\w-]+:[0-9a-f-]+' },
        accessKeyID: { type: 'string', minLength: 1, pattern: '[\\w]+' },
        secretKey: { type: 'string', minLength: 1 },
        sessionToken: { type: 'string', minLength: 1 },
        expiration: { type: 'string', format: 'date-time' },
        region: { type: 'string' }
    },
    required: ['identityID', 'accessKeyID', 'secretKey', 'sessionToken', 'expiration', 'region']
};
const pattern0 = new RegExp('[\\w-]+:[0-9a-f-]+', 'u');
const pattern1 = new RegExp('[\\w]+', 'u');
const func2 = ucs2length;
const formats0 = formatWrapper['date-time'];
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:AwsCredentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.identityID === undefined && (missing0 = 'identityID')) ||
                (data.accessKeyID === undefined && (missing0 = 'accessKeyID')) ||
                (data.secretKey === undefined && (missing0 = 'secretKey')) ||
                (data.sessionToken === undefined && (missing0 = 'sessionToken')) ||
                (data.expiration === undefined && (missing0 = 'expiration')) ||
                (data.region === undefined && (missing0 = 'region'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.identityID !== undefined) {
                    let data0 = data.identityID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern0.test(data0)) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/identityID',
                                        schemaPath: '#/properties/identityID/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: '[\\w-]+:[0-9a-f-]+' },
                                        message: 'must match pattern "' + '[\\w-]+:[0-9a-f-]+' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/identityID',
                                    schemaPath: '#/properties/identityID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.accessKeyID !== undefined) {
                        let data1 = data.accessKeyID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/accessKeyID',
                                            schemaPath: '#/properties/accessKeyID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (!pattern1.test(data1)) {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/accessKeyID',
                                                schemaPath: '#/properties/accessKeyID/pattern',
                                                keyword: 'pattern',
                                                params: { pattern: '[\\w]+' },
                                                message: 'must match pattern "' + '[\\w]+' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/accessKeyID',
                                        schemaPath: '#/properties/accessKeyID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.secretKey !== undefined) {
                            let data2 = data.secretKey;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/secretKey',
                                                schemaPath: '#/properties/secretKey/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/secretKey',
                                            schemaPath: '#/properties/secretKey/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.sessionToken !== undefined) {
                                let data3 = data.sessionToken;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/sessionToken',
                                                    schemaPath: '#/properties/sessionToken/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/sessionToken',
                                                schemaPath: '#/properties/sessionToken/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.expiration !== undefined) {
                                    let data4 = data.expiration;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate12.errors = [
                                                        {
                                                            instancePath: instancePath + '/expiration',
                                                            schemaPath: '#/properties/expiration/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate12.errors = [
                                                    {
                                                        instancePath: instancePath + '/expiration',
                                                        schemaPath: '#/properties/expiration/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.region !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.region !== 'string') {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/region',
                                                    schemaPath: '#/properties/region/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const deleteOrgEventSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-common-auth:DeleteOrgEvent',
    type: 'object',
    properties: { orgID: { type: 'string', format: 'uuid' } },
    required: ['orgID']
};
const formats2 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:DeleteOrgEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.orgID === undefined && (missing0 = 'orgID')) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const deleteUserEventSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-common-auth:DeleteUserEvent',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        orgIDs: { type: 'array', items: { type: 'string', format: 'uuid' } },
        retry: { type: 'number' }
    },
    required: ['userID', 'orgIDs']
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:DeleteUserEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userID === undefined && (missing0 = 'userID')) ||
                (data.orgIDs === undefined && (missing0 = 'orgIDs'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgIDs !== undefined) {
                        let data1 = data.orgIDs;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (errors === _errs5) {
                                        if (errors === _errs5) {
                                            if (typeof data2 === 'string') {
                                                if (!formats2.test(data2)) {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgIDs/' + i0,
                                                            schemaPath: '#/properties/orgIDs/items/format',
                                                            keyword: 'format',
                                                            params: { format: 'uuid' },
                                                            message: 'must match format "' + 'uuid' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgIDs/' + i0,
                                                        schemaPath: '#/properties/orgIDs/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/orgIDs',
                                        schemaPath: '#/properties/orgIDs/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.retry !== undefined) {
                            const _errs7 = errors;
                            if (!(typeof data.retry == 'number')) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/retry',
                                        schemaPath: '#/properties/retry/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const encryptionKeyInfoSchemaValidation = validate15;
const schema32 = {
    $id: 'urn:wisepipe-common-auth:EncryptionKeyInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        keyID: { type: 'string', uid: 9 },
        keyName: { type: 'string', minLength: 1 },
        publicKey: { type: 'string', minLength: 1 },
        createdAt: { type: 'string', format: 'date-time' },
        expireAt: { type: 'string', format: 'date-time' }
    },
    required: ['orgID', 'keyID', 'keyName', 'publicKey', 'createdAt']
};
const func5 = ucs2length;
const func6 = base64urlToBuffer;
const func7 = base64urlEncode;
const func8 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:EncryptionKeyInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.keyID === undefined && (missing0 = 'keyID')) ||
                (data.keyName === undefined && (missing0 = 'keyName')) ||
                (data.publicKey === undefined && (missing0 = 'publicKey')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt'))) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.keyID !== undefined) {
                        let data1 = data.keyID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func5(data1) < b64min0 || func5(data1) > b64max0) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/keyID',
                                            schemaPath: '#/properties/keyID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func5(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func5(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func6(data1);
                                    if (decoded0.length !== 9) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/keyID',
                                                schemaPath: '#/properties/keyID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func7(decoded0);
                                        if (func8(encoded0) !== func8(data1)) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/keyID',
                                                    schemaPath: '#/properties/keyID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/keyID',
                                        schemaPath: '#/properties/keyID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.keyName !== undefined) {
                            let data2 = data.keyName;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/keyName',
                                                schemaPath: '#/properties/keyName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/keyName',
                                            schemaPath: '#/properties/keyName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.publicKey !== undefined) {
                                let data3 = data.publicKey;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/publicKey',
                                                    schemaPath: '#/properties/publicKey/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/publicKey',
                                                schemaPath: '#/properties/publicKey/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.createdAt !== undefined) {
                                    let data4 = data.createdAt;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate15.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.expireAt !== undefined) {
                                        let data5 = data.expireAt;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.validate(data5)) {
                                                        validate15.errors = [
                                                            {
                                                                instancePath: instancePath + '/expireAt',
                                                                schemaPath: '#/properties/expireAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/expireAt',
                                                            schemaPath: '#/properties/expireAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const encryptionKeySecretInfoSchemaValidation = validate16;
const schema33 = {
    $id: 'urn:wisepipe-common-auth:EncryptionKeySecretInfo',
    type: 'object',
    properties: { secretName: { type: 'string', minLength: 1 } },
    required: ['secretName']
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:EncryptionKeySecretInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.secretName === undefined && (missing0 = 'secretName')) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.secretName !== undefined) {
                    let data0 = data.secretName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/secretName',
                                        schemaPath: '#/properties/secretName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/secretName',
                                    schemaPath: '#/properties/secretName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const idpInfoSchemaValidation = validate17;
const schema34 = {
    $id: 'urn:wisepipe-common-auth:IdpInfoSchema',
    type: 'object',
    properties: {
        id: { type: 'string', minLength: 1, format: 'uuid' },
        domainName: { type: 'string', minLength: 1 },
        idpName: { type: 'string', minLength: 1 },
        displayName: { type: 'string', minLength: 1 },
        connectedOrgs: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:OrgInfo' } }
    }
};
const schema35 = {
    $id: 'urn:wisepipe-domain-authorize:OrgInfo',
    type: 'object',
    properties: {
        id: { type: 'string', format: 'uuid' },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        initialCredit: { type: 'number', minimum: 0 },
        seats: { type: 'number', minimum: 0 },
        createdAt: { type: 'string', format: 'date-time' },
        supportedLoginTypes: { type: 'array', items: { type: 'string' } },
        featureFlags: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:OrgFeatureFlag' } },
        salesforceAcctId: { type: 'string' },
        orgType: { type: 'string', enum: ['DEV', 'QA', 'PROD'] },
        orgTimezone: { type: 'string', minLength: 1 }
    },
    required: ['id', 'name', 'orgPlan', 'initialCredit', 'seats']
};
const schema36 = {
    $id: 'urn:wisepipe-domain-authorize:OrgFeatureFlag',
    type: 'object',
    properties: {
        flagName: {
            type: 'string',
            enum: [
                'joinCaseInsensitive',
                'symonSparkPartitionNumber',
                'symonForceDecimal',
                'requireChangeRequest',
                'incentivesRoles',
                'incentivesS3DataProcessing'
            ]
        },
        flagValue: { type: 'string' },
        objectId: { type: 'string' },
        objectType: { type: 'string' }
    },
    required: ['flagName', 'flagValue']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.id === undefined && (missing0 = 'id')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan')) ||
                (data.initialCredit === undefined && (missing0 = 'initialCredit')) ||
                (data.seats === undefined && (missing0 = 'seats'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    let data0 = data.id;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate18.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgPlan !== undefined) {
                            let data2 = data.orgPlan;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'Social' ||
                                data2 === 'Enterprise' ||
                                data2 === 'Integration' ||
                                data2 === 'Temp' ||
                                data2 === 'Starter' ||
                                data2 === 'Professional')) {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema35.properties.orgPlan.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.initialCredit !== undefined) {
                                let data3 = data.initialCredit;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 0 || isNaN(data3)) {
                                            validate18.errors = [
                                                {
                                                    instancePath: instancePath + '/initialCredit',
                                                    schemaPath: '#/properties/initialCredit/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate18.errors = [
                                            {
                                                instancePath: instancePath + '/initialCredit',
                                                schemaPath: '#/properties/initialCredit/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.seats !== undefined) {
                                    let data4 = data.seats;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 == 'number') {
                                            if (data4 < 0 || isNaN(data4)) {
                                                validate18.errors = [
                                                    {
                                                        instancePath: instancePath + '/seats',
                                                        schemaPath: '#/properties/seats/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate18.errors = [
                                                {
                                                    instancePath: instancePath + '/seats',
                                                    schemaPath: '#/properties/seats/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.createdAt !== undefined) {
                                        let data5 = data.createdAt;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.validate(data5)) {
                                                        validate18.errors = [
                                                            {
                                                                instancePath: instancePath + '/createdAt',
                                                                schemaPath: '#/properties/createdAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate18.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.supportedLoginTypes !== undefined) {
                                            let data6 = data.supportedLoginTypes;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (Array.isArray(data6)) {
                                                    var valid1 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        const _errs15 = errors;
                                                        if (typeof data6[i0] !== 'string') {
                                                            validate18.errors = [
                                                                {
                                                                    instancePath: instancePath + '/supportedLoginTypes/' + i0,
                                                                    schemaPath: '#/properties/supportedLoginTypes/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid1 = _errs15 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate18.errors = [
                                                        {
                                                            instancePath: instancePath + '/supportedLoginTypes',
                                                            schemaPath: '#/properties/supportedLoginTypes/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.featureFlags !== undefined) {
                                                let data8 = data.featureFlags;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (Array.isArray(data8)) {
                                                        var valid2 = true;
                                                        const len1 = data8.length;
                                                        for (let i1 = 0; i1 < len1; i1++) {
                                                            let data9 = data8[i1];
                                                            const _errs19 = errors;
                                                            const _errs20 = errors;
                                                            if (errors === _errs20) {
                                                                if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                                                    let missing1;
                                                                    if ((data9.flagName === undefined && (missing1 = 'flagName')) ||
                                                                        (data9.flagValue === undefined && (missing1 = 'flagValue'))) {
                                                                        validate18.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/featureFlags/' + i1,
                                                                                schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing1 },
                                                                                message: "must have required property '" + missing1 + "'"
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data9.flagName !== undefined) {
                                                                            let data10 = data9.flagName;
                                                                            const _errs22 = errors;
                                                                            if (typeof data10 !== 'string') {
                                                                                validate18.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/featureFlags/' + i1 + '/flagName',
                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/flagName/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            if (!(data10 === 'joinCaseInsensitive' ||
                                                                                data10 === 'symonSparkPartitionNumber' ||
                                                                                data10 === 'symonForceDecimal' ||
                                                                                data10 === 'requireChangeRequest' ||
                                                                                data10 === 'incentivesRoles' ||
                                                                                data10 === 'incentivesS3DataProcessing')) {
                                                                                validate18.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/featureFlags/' + i1 + '/flagName',
                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/flagName/enum',
                                                                                        keyword: 'enum',
                                                                                        params: { allowedValues: schema36.properties.flagName.enum },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid4 = _errs22 === errors;
                                                                        }
                                                                        else {
                                                                            var valid4 = true;
                                                                        }
                                                                        if (valid4) {
                                                                            if (data9.flagValue !== undefined) {
                                                                                const _errs24 = errors;
                                                                                if (typeof data9.flagValue !== 'string') {
                                                                                    validate18.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/featureFlags/' + i1 + '/flagValue',
                                                                                            schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/flagValue/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid4 = _errs24 === errors;
                                                                            }
                                                                            else {
                                                                                var valid4 = true;
                                                                            }
                                                                            if (valid4) {
                                                                                if (data9.objectId !== undefined) {
                                                                                    const _errs26 = errors;
                                                                                    if (typeof data9.objectId !== 'string') {
                                                                                        validate18.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/featureFlags/' + i1 + '/objectId',
                                                                                                schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/objectId/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid4 = _errs26 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid4 = true;
                                                                                }
                                                                                if (valid4) {
                                                                                    if (data9.objectType !== undefined) {
                                                                                        const _errs28 = errors;
                                                                                        if (typeof data9.objectType !== 'string') {
                                                                                            validate18.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/featureFlags/' + i1 + '/objectType',
                                                                                                    schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/objectType/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid4 = _errs28 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid4 = true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate18.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/featureFlags/' + i1,
                                                                            schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs19 === errors;
                                                            if (!valid2) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate18.errors = [
                                                            {
                                                                instancePath: instancePath + '/featureFlags',
                                                                schemaPath: '#/properties/featureFlags/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.salesforceAcctId !== undefined) {
                                                    const _errs30 = errors;
                                                    if (typeof data.salesforceAcctId !== 'string') {
                                                        validate18.errors = [
                                                            {
                                                                instancePath: instancePath + '/salesforceAcctId',
                                                                schemaPath: '#/properties/salesforceAcctId/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs30 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.orgType !== undefined) {
                                                        let data15 = data.orgType;
                                                        const _errs32 = errors;
                                                        if (typeof data15 !== 'string') {
                                                            validate18.errors = [
                                                                {
                                                                    instancePath: instancePath + '/orgType',
                                                                    schemaPath: '#/properties/orgType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data15 === 'DEV' || data15 === 'QA' || data15 === 'PROD')) {
                                                            validate18.errors = [
                                                                {
                                                                    instancePath: instancePath + '/orgType',
                                                                    schemaPath: '#/properties/orgType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema35.properties.orgType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs32 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.orgTimezone !== undefined) {
                                                            let data16 = data.orgTimezone;
                                                            const _errs34 = errors;
                                                            if (errors === _errs34) {
                                                                if (typeof data16 === 'string') {
                                                                    if (func2(data16) < 1) {
                                                                        validate18.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/orgTimezone',
                                                                                schemaPath: '#/properties/orgTimezone/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate18.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/orgTimezone',
                                                                            schemaPath: '#/properties/orgTimezone/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs34 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:IdpInfoSchema" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.id !== undefined) {
                let data0 = data.id;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (!formats2.test(data0)) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/id',
                                    schemaPath: '#/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.domainName !== undefined) {
                    let data1 = data.domainName;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/domainName',
                                        schemaPath: '#/properties/domainName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/domainName',
                                    schemaPath: '#/properties/domainName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.idpName !== undefined) {
                        let data2 = data.idpName;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/idpName',
                                            schemaPath: '#/properties/idpName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/idpName',
                                        schemaPath: '#/properties/idpName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.displayName !== undefined) {
                            let data3 = data.displayName;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/displayName',
                                                schemaPath: '#/properties/displayName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/displayName',
                                            schemaPath: '#/properties/displayName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.connectedOrgs !== undefined) {
                                let data4 = data.connectedOrgs;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        var valid1 = true;
                                        const len0 = data4.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs11 = errors;
                                            if (!validate18(data4[i0], {
                                                instancePath: instancePath + '/connectedOrgs/' + i0,
                                                parentData: data4,
                                                parentDataProperty: i0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate18.errors : vErrors.concat(validate18.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid1 = _errs11 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/connectedOrgs',
                                                schemaPath: '#/properties/connectedOrgs/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const joinOrgEventSchemaValidation = validate20;
const schema37 = {
    $id: 'urn:wisepipe-common-auth:JoinOrgEvent',
    type: 'object',
    properties: { orgID: { type: 'string', format: 'uuid' }, userID: { type: 'string', minLength: 1, maxLength: 128 } },
    required: ['orgID', 'userID']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:JoinOrgEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) || (data.userID === undefined && (missing0 = 'userID'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 128) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 128 },
                                            message: 'must NOT have more than 128 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const leaveOrgEventSchemaValidation = validate21;
const schema38 = {
    $id: 'urn:wisepipe-common-auth:LeaveOrgEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        isInitial: { type: 'boolean' }
    },
    required: ['orgID', 'userID']
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:LeaveOrgEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) || (data.userID === undefined && (missing0 = 'userID'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats2.test(data1)) {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.isInitial !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.isInitial !== 'boolean') {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/isInitial',
                                        schemaPath: '#/properties/isInitial/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const newOrgEventSchemaValidation = validate22;
const schema39 = {
    $id: 'urn:wisepipe-common-auth:NewOrgEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        credits: { type: 'number' },
        seats: { type: 'number', minimum: 1 },
        orgPlan: { type: 'string' },
        subscriptionType: {
            type: 'string',
            enum: [
                'plg',
                'varicentAdvantageAnalytics',
                'varicentELT',
                'varicentAI',
                'varicentSalesPlanning',
                'varicentDesigner'
            ]
        }
    },
    required: ['orgID', 'credits', 'seats', 'orgPlan']
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:NewOrgEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.credits === undefined && (missing0 = 'credits')) ||
                (data.seats === undefined && (missing0 = 'seats')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan'))) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.credits !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.credits == 'number')) {
                            validate22.errors = [
                                {
                                    instancePath: instancePath + '/credits',
                                    schemaPath: '#/properties/credits/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.seats !== undefined) {
                            let data2 = data.seats;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 < 1 || isNaN(data2)) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/seats',
                                                schemaPath: '#/properties/seats/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 1 },
                                                message: 'must be >= 1'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/seats',
                                            schemaPath: '#/properties/seats/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.orgPlan !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.orgPlan !== 'string') {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.subscriptionType !== undefined) {
                                    let data4 = data.subscriptionType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/subscriptionType',
                                                schemaPath: '#/properties/subscriptionType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'plg' ||
                                        data4 === 'varicentAdvantageAnalytics' ||
                                        data4 === 'varicentELT' ||
                                        data4 === 'varicentAI' ||
                                        data4 === 'varicentSalesPlanning' ||
                                        data4 === 'varicentDesigner')) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/subscriptionType',
                                                schemaPath: '#/properties/subscriptionType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema39.properties.subscriptionType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const newUserEventSchemaValidation = validate23;
const schema40 = {
    $id: 'urn:wisepipe-common-auth:NewUserEvent',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userEmail: { type: 'string' },
        name: { type: 'string' },
        isIntegrationUser: { type: 'boolean' },
        orgID: { type: 'string', format: 'uuid' }
    },
    required: ['userID', 'userEmail', 'isIntegrationUser']
};
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:NewUserEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userID === undefined && (missing0 = 'userID')) ||
                (data.userEmail === undefined && (missing0 = 'userEmail')) ||
                (data.isIntegrationUser === undefined && (missing0 = 'isIntegrationUser'))) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userEmail !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.userEmail !== 'string') {
                            validate23.errors = [
                                {
                                    instancePath: instancePath + '/userEmail',
                                    schemaPath: '#/properties/userEmail/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.name !== 'string') {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.isIntegrationUser !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.isIntegrationUser !== 'boolean') {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/isIntegrationUser',
                                            schemaPath: '#/properties/isIntegrationUser/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.orgID !== undefined) {
                                    let data4 = data.orgID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats2.test(data4)) {
                                                    validate23.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgID',
                                                            schemaPath: '#/properties/orgID/format',
                                                            keyword: 'format',
                                                            params: { format: 'uuid' },
                                                            message: 'must match format "' + 'uuid' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate23.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgID',
                                                        schemaPath: '#/properties/orgID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const orgFeatureFlagSchemaValidation = validate24;
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgFeatureFlag" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.flagName === undefined && (missing0 = 'flagName')) ||
                (data.flagValue === undefined && (missing0 = 'flagValue'))) {
                validate24.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.flagName !== undefined) {
                    let data0 = data.flagName;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate24.errors = [
                            {
                                instancePath: instancePath + '/flagName',
                                schemaPath: '#/properties/flagName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'joinCaseInsensitive' ||
                        data0 === 'symonSparkPartitionNumber' ||
                        data0 === 'symonForceDecimal' ||
                        data0 === 'requireChangeRequest' ||
                        data0 === 'incentivesRoles' ||
                        data0 === 'incentivesS3DataProcessing')) {
                        validate24.errors = [
                            {
                                instancePath: instancePath + '/flagName',
                                schemaPath: '#/properties/flagName/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema36.properties.flagName.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.flagValue !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.flagValue !== 'string') {
                            validate24.errors = [
                                {
                                    instancePath: instancePath + '/flagValue',
                                    schemaPath: '#/properties/flagValue/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.objectId !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.objectId !== 'string') {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/objectId',
                                        schemaPath: '#/properties/objectId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.objectType !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.objectType !== 'string') {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/objectType',
                                            schemaPath: '#/properties/objectType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate24.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
export const orgInfoSchemaValidation = validate18;
export const orgUserInviteSchemaValidation = validate25;
const schema42 = {
    $id: 'urn:wisepipe-domain-authorize:OrgUserInvite',
    type: 'object',
    properties: {
        orgInfo: { $ref: 'urn:wisepipe-domain-authorize:OrgInfo' },
        userEmail: { type: 'string', minLength: 1 },
        inviterUserID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        cognitoUserID: { type: 'string' },
        roleID: { type: 'string', format: 'uuid' },
        supportUser: { type: 'boolean' },
        currentRoleID: { type: 'string', format: 'uuid' },
        createdAt: { type: 'string', format: 'date-time' },
        acceptedAt: { type: 'string', format: 'date-time' },
        rejectedAt: { type: 'string', format: 'date-time' }
    },
    required: ['orgInfo', 'userEmail', 'createdAt'],
    not: { required: ['acceptedAt', 'rejectedAt'] }
};
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgUserInvite" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if ((data.acceptedAt === undefined && (missing0 = 'acceptedAt')) ||
            (data.rejectedAt === undefined && (missing0 = 'rejectedAt'))) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var valid0 = _errs2 === errors;
    if (valid0) {
        validate25.errors = [
            { instancePath, schemaPath: '#/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
        ];
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.orgInfo === undefined && (missing1 = 'orgInfo')) ||
                (data.userEmail === undefined && (missing1 = 'userEmail')) ||
                (data.createdAt === undefined && (missing1 = 'createdAt'))) {
                validate25.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgInfo !== undefined) {
                    const _errs3 = errors;
                    if (!validate18(data.orgInfo, {
                        instancePath: instancePath + '/orgInfo',
                        parentData: data,
                        parentDataProperty: 'orgInfo',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate18.errors : vErrors.concat(validate18.errors);
                        errors = vErrors.length;
                    }
                    var valid1 = _errs3 === errors;
                }
                else {
                    var valid1 = true;
                }
                if (valid1) {
                    if (data.userEmail !== undefined) {
                        let data1 = data.userEmail;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/userEmail',
                                            schemaPath: '#/properties/userEmail/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/userEmail',
                                        schemaPath: '#/properties/userEmail/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid1 = _errs4 === errors;
                    }
                    else {
                        var valid1 = true;
                    }
                    if (valid1) {
                        if (data.inviterUserID !== undefined) {
                            let data2 = data.inviterUserID;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (errors === _errs6) {
                                    if (typeof data2 === 'string') {
                                        if (!formats2.test(data2)) {
                                            validate25.errors = [
                                                {
                                                    instancePath: instancePath + '/inviterUserID',
                                                    schemaPath: '#/properties/inviterUserID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/inviterUserID',
                                                schemaPath: '#/properties/inviterUserID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid1 = _errs6 === errors;
                        }
                        else {
                            var valid1 = true;
                        }
                        if (valid1) {
                            if (data.userID !== undefined) {
                                let data3 = data.userID;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                    if (errors === _errs8) {
                                        if (typeof data3 === 'string') {
                                            if (!formats2.test(data3)) {
                                                validate25.errors = [
                                                    {
                                                        instancePath: instancePath + '/userID',
                                                        schemaPath: '#/properties/userID/format',
                                                        keyword: 'format',
                                                        params: { format: 'uuid' },
                                                        message: 'must match format "' + 'uuid' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate25.errors = [
                                                {
                                                    instancePath: instancePath + '/userID',
                                                    schemaPath: '#/properties/userID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid1 = _errs8 === errors;
                            }
                            else {
                                var valid1 = true;
                            }
                            if (valid1) {
                                if (data.cognitoUserID !== undefined) {
                                    const _errs10 = errors;
                                    if (typeof data.cognitoUserID !== 'string') {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/cognitoUserID',
                                                schemaPath: '#/properties/cognitoUserID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs10 === errors;
                                }
                                else {
                                    var valid1 = true;
                                }
                                if (valid1) {
                                    if (data.roleID !== undefined) {
                                        let data5 = data.roleID;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (errors === _errs12) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats2.test(data5)) {
                                                        validate25.errors = [
                                                            {
                                                                instancePath: instancePath + '/roleID',
                                                                schemaPath: '#/properties/roleID/format',
                                                                keyword: 'format',
                                                                params: { format: 'uuid' },
                                                                message: 'must match format "' + 'uuid' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate25.errors = [
                                                        {
                                                            instancePath: instancePath + '/roleID',
                                                            schemaPath: '#/properties/roleID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid1 = _errs12 === errors;
                                    }
                                    else {
                                        var valid1 = true;
                                    }
                                    if (valid1) {
                                        if (data.supportUser !== undefined) {
                                            const _errs14 = errors;
                                            if (typeof data.supportUser !== 'boolean') {
                                                validate25.errors = [
                                                    {
                                                        instancePath: instancePath + '/supportUser',
                                                        schemaPath: '#/properties/supportUser/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid1 = _errs14 === errors;
                                        }
                                        else {
                                            var valid1 = true;
                                        }
                                        if (valid1) {
                                            if (data.currentRoleID !== undefined) {
                                                let data7 = data.currentRoleID;
                                                const _errs16 = errors;
                                                if (errors === _errs16) {
                                                    if (errors === _errs16) {
                                                        if (typeof data7 === 'string') {
                                                            if (!formats2.test(data7)) {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/currentRoleID',
                                                                        schemaPath: '#/properties/currentRoleID/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'uuid' },
                                                                        message: 'must match format "' + 'uuid' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate25.errors = [
                                                                {
                                                                    instancePath: instancePath + '/currentRoleID',
                                                                    schemaPath: '#/properties/currentRoleID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid1 = _errs16 === errors;
                                            }
                                            else {
                                                var valid1 = true;
                                            }
                                            if (valid1) {
                                                if (data.createdAt !== undefined) {
                                                    let data8 = data.createdAt;
                                                    const _errs18 = errors;
                                                    if (errors === _errs18) {
                                                        if (errors === _errs18) {
                                                            if (typeof data8 === 'string') {
                                                                if (!formats0.validate(data8)) {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/createdAt',
                                                                            schemaPath: '#/properties/createdAt/format',
                                                                            keyword: 'format',
                                                                            params: { format: 'date-time' },
                                                                            message: 'must match format "' + 'date-time' + '"'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/createdAt',
                                                                        schemaPath: '#/properties/createdAt/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var valid1 = _errs18 === errors;
                                                }
                                                else {
                                                    var valid1 = true;
                                                }
                                                if (valid1) {
                                                    if (data.acceptedAt !== undefined) {
                                                        let data9 = data.acceptedAt;
                                                        const _errs20 = errors;
                                                        if (errors === _errs20) {
                                                            if (errors === _errs20) {
                                                                if (typeof data9 === 'string') {
                                                                    if (!formats0.validate(data9)) {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/acceptedAt',
                                                                                schemaPath: '#/properties/acceptedAt/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/acceptedAt',
                                                                            schemaPath: '#/properties/acceptedAt/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid1 = _errs20 === errors;
                                                    }
                                                    else {
                                                        var valid1 = true;
                                                    }
                                                    if (valid1) {
                                                        if (data.rejectedAt !== undefined) {
                                                            let data10 = data.rejectedAt;
                                                            const _errs22 = errors;
                                                            if (errors === _errs22) {
                                                                if (errors === _errs22) {
                                                                    if (typeof data10 === 'string') {
                                                                        if (!formats0.validate(data10)) {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/rejectedAt',
                                                                                    schemaPath: '#/properties/rejectedAt/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate25.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/rejectedAt',
                                                                                schemaPath: '#/properties/rejectedAt/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid1 = _errs22 === errors;
                                                        }
                                                        else {
                                                            var valid1 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate25.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
export const taskAuthInfoSchemaValidation = validate27;
const schema43 = {
    $id: 'urn:wisepipe-common-auth:TaskAuthInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        taskID: { type: 'string' },
        taskAuthToken: { type: 'string' },
        expiration: { type: 'integer' },
        endpoint: { type: 'string' }
    },
    required: ['orgID', 'userID', 'taskID', 'taskAuthToken', 'expiration']
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:TaskAuthInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.taskAuthToken === undefined && (missing0 = 'taskAuthToken')) ||
                (data.expiration === undefined && (missing0 = 'expiration'))) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats2.test(data1)) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.taskID !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.taskID !== 'string') {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.taskAuthToken !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.taskAuthToken !== 'string') {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/taskAuthToken',
                                            schemaPath: '#/properties/taskAuthToken/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.expiration !== undefined) {
                                    let data4 = data.expiration;
                                    const _errs9 = errors;
                                    if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/expiration',
                                                schemaPath: '#/properties/expiration/type',
                                                keyword: 'type',
                                                params: { type: 'integer' },
                                                message: 'must be integer'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.endpoint !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.endpoint !== 'string') {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/endpoint',
                                                    schemaPath: '#/properties/endpoint/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const tempUserCredentialsSchemaValidation = validate28;
const schema44 = {
    $id: 'urn:wisepipe-common-auth:TempUserCredentials',
    type: 'object',
    properties: {
        idToken: { type: 'string', pattern: '[A-Za-z0-9-_=.]+' },
        refreshToken: { type: 'string', pattern: '[A-Za-z0-9-_=.]+' },
        accessToken: { type: 'string' }
    },
    required: ['idToken', 'refreshToken']
};
const pattern2 = new RegExp('[A-Za-z0-9-_=.]+', 'u');
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:TempUserCredentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.idToken === undefined && (missing0 = 'idToken')) ||
                (data.refreshToken === undefined && (missing0 = 'refreshToken'))) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.idToken !== undefined) {
                    let data0 = data.idToken;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern2.test(data0)) {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/idToken',
                                        schemaPath: '#/properties/idToken/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: '[A-Za-z0-9-_=.]+' },
                                        message: 'must match pattern "' + '[A-Za-z0-9-_=.]+' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/idToken',
                                    schemaPath: '#/properties/idToken/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.refreshToken !== undefined) {
                        let data1 = data.refreshToken;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (!pattern2.test(data1)) {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/refreshToken',
                                            schemaPath: '#/properties/refreshToken/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: '[A-Za-z0-9-_=.]+' },
                                            message: 'must match pattern "' + '[A-Za-z0-9-_=.]+' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/refreshToken',
                                        schemaPath: '#/properties/refreshToken/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.accessToken !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.accessToken !== 'string') {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/accessToken',
                                        schemaPath: '#/properties/accessToken/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const tempUserInfoSchemaValidation = validate29;
const schema45 = {
    $id: 'urn:wisepipe-common-auth:TempUserInfo',
    type: 'object',
    properties: {
        tempUserCredentials: { $ref: 'urn:wisepipe-common-auth:TempUserCredentials' },
        invite: { $ref: 'urn:wisepipe-domain-authorize:OrgUserInvite' }
    },
    required: ['tempUserCredentials', 'invite']
};
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:TempUserInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.tempUserCredentials === undefined && (missing0 = 'tempUserCredentials')) ||
                (data.invite === undefined && (missing0 = 'invite'))) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.tempUserCredentials !== undefined) {
                    let data0 = data.tempUserCredentials;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.idToken === undefined && (missing1 = 'idToken')) ||
                                (data0.refreshToken === undefined && (missing1 = 'refreshToken'))) {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/tempUserCredentials',
                                        schemaPath: 'urn:wisepipe-common-auth:TempUserCredentials/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.idToken !== undefined) {
                                    let data1 = data0.idToken;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (!pattern2.test(data1)) {
                                                validate29.errors = [
                                                    {
                                                        instancePath: instancePath + '/tempUserCredentials/idToken',
                                                        schemaPath: 'urn:wisepipe-common-auth:TempUserCredentials/properties/idToken/pattern',
                                                        keyword: 'pattern',
                                                        params: { pattern: '[A-Za-z0-9-_=.]+' },
                                                        message: 'must match pattern "' + '[A-Za-z0-9-_=.]+' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate29.errors = [
                                                {
                                                    instancePath: instancePath + '/tempUserCredentials/idToken',
                                                    schemaPath: 'urn:wisepipe-common-auth:TempUserCredentials/properties/idToken/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.refreshToken !== undefined) {
                                        let data2 = data0.refreshToken;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (!pattern2.test(data2)) {
                                                    validate29.errors = [
                                                        {
                                                            instancePath: instancePath + '/tempUserCredentials/refreshToken',
                                                            schemaPath: 'urn:wisepipe-common-auth:TempUserCredentials/properties/refreshToken/pattern',
                                                            keyword: 'pattern',
                                                            params: { pattern: '[A-Za-z0-9-_=.]+' },
                                                            message: 'must match pattern "' + '[A-Za-z0-9-_=.]+' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate29.errors = [
                                                    {
                                                        instancePath: instancePath + '/tempUserCredentials/refreshToken',
                                                        schemaPath: 'urn:wisepipe-common-auth:TempUserCredentials/properties/refreshToken/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.accessToken !== undefined) {
                                            const _errs8 = errors;
                                            if (typeof data0.accessToken !== 'string') {
                                                validate29.errors = [
                                                    {
                                                        instancePath: instancePath + '/tempUserCredentials/accessToken',
                                                        schemaPath: 'urn:wisepipe-common-auth:TempUserCredentials/properties/accessToken/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate29.errors = [
                                {
                                    instancePath: instancePath + '/tempUserCredentials',
                                    schemaPath: 'urn:wisepipe-common-auth:TempUserCredentials/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.invite !== undefined) {
                        const _errs10 = errors;
                        if (!validate25(data.invite, {
                            instancePath: instancePath + '/invite',
                            parentData: data,
                            parentDataProperty: 'invite',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate29.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const tempUserSchemaValidation = validate31;
const schema47 = {
    $id: 'urn:wisepipe-common-auth:TempUser',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userEmail: { type: 'string' },
        confirmationCode: { type: 'string' },
        emailVerified: { type: 'boolean' },
        confirmationCodeRetries: { type: 'number' },
        orgID: { type: 'string', format: 'uuid' }
    },
    required: ['userID', 'userEmail', 'confirmationCode', 'confirmationCodeRetries']
};
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:TempUser" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userID === undefined && (missing0 = 'userID')) ||
                (data.userEmail === undefined && (missing0 = 'userEmail')) ||
                (data.confirmationCode === undefined && (missing0 = 'confirmationCode')) ||
                (data.confirmationCodeRetries === undefined && (missing0 = 'confirmationCodeRetries'))) {
                validate31.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate31.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userEmail !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.userEmail !== 'string') {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/userEmail',
                                    schemaPath: '#/properties/userEmail/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.confirmationCode !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.confirmationCode !== 'string') {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/confirmationCode',
                                        schemaPath: '#/properties/confirmationCode/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.emailVerified !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.emailVerified !== 'boolean') {
                                    validate31.errors = [
                                        {
                                            instancePath: instancePath + '/emailVerified',
                                            schemaPath: '#/properties/emailVerified/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.confirmationCodeRetries !== undefined) {
                                    const _errs9 = errors;
                                    if (!(typeof data.confirmationCodeRetries == 'number')) {
                                        validate31.errors = [
                                            {
                                                instancePath: instancePath + '/confirmationCodeRetries',
                                                schemaPath: '#/properties/confirmationCodeRetries/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.orgID !== undefined) {
                                        let data5 = data.orgID;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats2.test(data5)) {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/orgID',
                                                                schemaPath: '#/properties/orgID/format',
                                                                keyword: 'format',
                                                                params: { format: 'uuid' },
                                                                message: 'must match format "' + 'uuid' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate31.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgID',
                                                            schemaPath: '#/properties/orgID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
export const updateUserEventSchemaValidation = validate32;
const schema48 = {
    $id: 'urn:wisepipe-common-auth:UpdateUserEvent',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        oldEmail: { type: 'string' },
        newEmail: { type: 'string' }
    },
    required: ['userID', 'oldEmail']
};
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:UpdateUserEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userID === undefined && (missing0 = 'userID')) ||
                (data.oldEmail === undefined && (missing0 = 'oldEmail'))) {
                validate32.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate32.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.oldEmail !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.oldEmail !== 'string') {
                            validate32.errors = [
                                {
                                    instancePath: instancePath + '/oldEmail',
                                    schemaPath: '#/properties/oldEmail/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.newEmail !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.newEmail !== 'string') {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/newEmail',
                                        schemaPath: '#/properties/newEmail/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate32.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const userEventSchemaValidation = validate33;
const schema49 = {
    $id: 'urn:wisepipe-common-auth:UserEvent',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userEmail: { type: 'string' },
        name: { type: 'string' },
        eventType: {
            type: 'string',
            enum: [
                'integrationUserSignup',
                'tempUserSignup',
                'tempUserConfirmEmail',
                'socialSSOSignUp',
                'cognitoSignup',
                'cognitoSocialSignup',
                'cognitoEnterpriseSignup'
            ]
        },
        orgID: { type: 'string', format: 'uuid' },
        integrationSource: { type: 'string', minLength: 1 },
        integrationSourceID: { type: 'string' },
        subscriptionType: {
            type: 'string',
            enum: [
                'plg',
                'varicentAdvantageAnalytics',
                'varicentELT',
                'varicentAI',
                'varicentSalesPlanning',
                'varicentDesigner'
            ]
        },
        isSystemUser: { type: 'boolean' }
    },
    required: ['userID', 'userEmail', 'eventType']
};
function validate33(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:UserEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userID === undefined && (missing0 = 'userID')) ||
                (data.userEmail === undefined && (missing0 = 'userEmail')) ||
                (data.eventType === undefined && (missing0 = 'eventType'))) {
                validate33.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userEmail !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.userEmail !== 'string') {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/userEmail',
                                    schemaPath: '#/properties/userEmail/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.name !== 'string') {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.eventType !== undefined) {
                                let data3 = data.eventType;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/eventType',
                                            schemaPath: '#/properties/eventType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'integrationUserSignup' ||
                                    data3 === 'tempUserSignup' ||
                                    data3 === 'tempUserConfirmEmail' ||
                                    data3 === 'socialSSOSignUp' ||
                                    data3 === 'cognitoSignup' ||
                                    data3 === 'cognitoSocialSignup' ||
                                    data3 === 'cognitoEnterpriseSignup')) {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/eventType',
                                            schemaPath: '#/properties/eventType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema49.properties.eventType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.orgID !== undefined) {
                                    let data4 = data.orgID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats2.test(data4)) {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgID',
                                                            schemaPath: '#/properties/orgID/format',
                                                            keyword: 'format',
                                                            params: { format: 'uuid' },
                                                            message: 'must match format "' + 'uuid' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate33.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgID',
                                                        schemaPath: '#/properties/orgID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.integrationSource !== undefined) {
                                        let data5 = data.integrationSource;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/integrationSource',
                                                            schemaPath: '#/properties/integrationSource/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate33.errors = [
                                                    {
                                                        instancePath: instancePath + '/integrationSource',
                                                        schemaPath: '#/properties/integrationSource/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.integrationSourceID !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.integrationSourceID !== 'string') {
                                                validate33.errors = [
                                                    {
                                                        instancePath: instancePath + '/integrationSourceID',
                                                        schemaPath: '#/properties/integrationSourceID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.subscriptionType !== undefined) {
                                                let data7 = data.subscriptionType;
                                                const _errs15 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/subscriptionType',
                                                            schemaPath: '#/properties/subscriptionType/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'plg' ||
                                                    data7 === 'varicentAdvantageAnalytics' ||
                                                    data7 === 'varicentELT' ||
                                                    data7 === 'varicentAI' ||
                                                    data7 === 'varicentSalesPlanning' ||
                                                    data7 === 'varicentDesigner')) {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/subscriptionType',
                                                            schemaPath: '#/properties/subscriptionType/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema49.properties.subscriptionType.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.isSystemUser !== undefined) {
                                                    const _errs17 = errors;
                                                    if (typeof data.isSystemUser !== 'boolean') {
                                                        validate33.errors = [
                                                            {
                                                                instancePath: instancePath + '/isSystemUser',
                                                                schemaPath: '#/properties/isSystemUser/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate33.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
export const userInfoSchemaValidation = validate34;
const schema50 = {
    $id: 'urn:wisepipe-common-auth:UserInfo',
    type: 'object',
    properties: {
        fullName: { type: 'string', minLength: 1 },
        email: { type: 'string', minLength: 1 },
        hash: { type: 'string', minLength: 1 },
        userPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration'] }
    }
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:UserInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.fullName !== undefined) {
                let data0 = data.fullName;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/fullName',
                                    schemaPath: '#/properties/fullName/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate34.errors = [
                            {
                                instancePath: instancePath + '/fullName',
                                schemaPath: '#/properties/fullName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.email !== undefined) {
                    let data1 = data.email;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/email',
                                        schemaPath: '#/properties/email/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/email',
                                    schemaPath: '#/properties/email/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.hash !== undefined) {
                        let data2 = data.hash;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/hash',
                                            schemaPath: '#/properties/hash/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/hash',
                                        schemaPath: '#/properties/hash/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.userPlan !== undefined) {
                            let data3 = data.userPlan;
                            const _errs7 = errors;
                            if (typeof data3 !== 'string') {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/userPlan',
                                        schemaPath: '#/properties/userPlan/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'Social' || data3 === 'Enterprise' || data3 === 'Integration')) {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/userPlan',
                                        schemaPath: '#/properties/userPlan/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema50.properties.userPlan.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const userLoginEventSchemaValidation = validate35;
const schema51 = {
    $id: 'urn:wisepipe-common-auth:userLoginEvent',
    type: 'object',
    properties: { userID: { type: 'string', format: 'uuid' }, loginAt: { type: 'string', format: 'date-time' } },
    required: ['userID', 'loginAt']
};
function validate35(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:userLoginEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userID === undefined && (missing0 = 'userID')) ||
                (data.loginAt === undefined && (missing0 = 'loginAt'))) {
                validate35.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data0 = data.userID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.loginAt !== undefined) {
                        let data1 = data.loginAt;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.validate(data1)) {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/loginAt',
                                                schemaPath: '#/properties/loginAt/format',
                                                keyword: 'format',
                                                params: { format: 'date-time' },
                                                message: 'must match format "' + 'date-time' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/loginAt',
                                            schemaPath: '#/properties/loginAt/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate35.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate35.errors = vErrors;
    return errors === 0;
}
export const versionInfoSchemaValidation = validate36;
const schema52 = {
    $id: 'urn:wisepipe-common-auth:VersionInfo',
    type: 'object',
    properties: {
        version: { type: 'string', minLength: 1 },
        timestamp: { type: 'string', minLength: 1 },
        commit: { type: 'string', minLength: 1 }
    },
    required: ['version', 'timestamp', 'commit']
};
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:VersionInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.version === undefined && (missing0 = 'version')) ||
                (data.timestamp === undefined && (missing0 = 'timestamp')) ||
                (data.commit === undefined && (missing0 = 'commit'))) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.version !== undefined) {
                    let data0 = data.version;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/version',
                                        schemaPath: '#/properties/version/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/version',
                                    schemaPath: '#/properties/version/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.timestamp !== undefined) {
                        let data1 = data.timestamp;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/timestamp',
                                            schemaPath: '#/properties/timestamp/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/timestamp',
                                        schemaPath: '#/properties/timestamp/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.commit !== undefined) {
                            let data2 = data.commit;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/commit',
                                                schemaPath: '#/properties/commit/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/commit',
                                            schemaPath: '#/properties/commit/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map